/**
 * Determina se um item de menu está ativo a partir do caminho atual da rota.
 * Compartilhado entre itens de primeiro nível e submenus.
 */
export function isMenuPathActive(currentPath: string, id: string): boolean {
  // Itens de agrupamento (sem rota real) nunca ficam ativos por si só.
  if (id.startsWith('#')) return false;

  if (currentPath === id) return true;

  if (currentPath.startsWith(id + '/')) {
    // Apólices não devem acender quando estamos na inspeção da apólice.
    if (id === '/policies' && currentPath.includes('/inspections/')) {
      return false;
    }
    return true;
  }

  if (id === '/inspections') {
    return (
      currentPath.includes('/inspections/') || currentPath === '/inspections'
    );
  }

  return false;
}
